module.exports = __webpack_public_path__ + "assets/img/a07d0fa8b6b10bfe866f7d5e2ba9279b.webp";